import React, { useState, useEffect } from "react";
import H3Image from '@Uilib/h3Image';
import H3Text from "@Uilib/h3Text";
import { cdnUrl } from "@Utils/cdnHelper";

const ServerDownBanner = ({ offtimeMsg }) => {
  return (
    <div className="server-down__wrapper">
      <H3Image src={cdnUrl("logo-without-tagline.png", "images")} className="server-down__logo" />
      <H3Text text={offtimeMsg} className="server-down__text" />
      <iframe src="https://procuzystoragebackup.blob.core.windows.net/s3-backup/dinosaur/index.html" />
    </div>
  );
};

export default ServerDownBanner;
